import React, { useEffect, useRef } from 'react';

import { isPathMatches } from '~/components/app-header/utils/navigation-utils';
import { useChatInputHandlers } from '~/components/chat/chat-input/chat-quick-analysis/useChatInputHandlers';
import { useChatInputNavigate } from '~/hooks/use-chat-input-navigate/useChatInputNavigate';
import { useChat } from '~/views/alfred/quick-analysis/use-chat/useChat';

import {
  ChatInputComposer,
  ChatInputComposerProps,
} from '../chat-input-composer/ChatInputComposer';
import { ChatInputConfig } from '../types';

export interface ChatInputProps
  extends Pick<ChatInputComposerProps, 'mode' | 'setMode'> {
  submitCallback?: (message?: string) => void;
  config?: ChatInputConfig;
}

export const ChatQuickAnalysis = ({
  submitCallback,
  config,
  ...rest
}: ChatInputProps) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const chatInputNavigation = useChatInputNavigate();

  const { isMessagePending, messages } = useChat(state => ({
    isMessagePending: state.isMessagePending,
    messages: state.messages,
  }));

  const isTargetPage = isPathMatches(['alfred', 'chart']);
  const isLoading = isTargetPage && isMessagePending;

  const handlers = useChatInputHandlers({
    config,
    submitCallback,
    isLoading,
  });

  useEffect(() => {
    const lastMessage = messages.at(-1);
    chatInputNavigation(lastMessage);
  }, [messages, chatInputNavigation]);

  return (
    <ChatInputComposer
      ref={inputRef}
      handlers={handlers}
      config={{
        ...config,
        isLoading,
      }}
      {...rest}
    />
  );
};
